<template>
  <v-container>
    <v-form ref="form" lazy-validation @submit.prevent="submit">
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="config.name"
            label="Navn"
            :rules="[rules.required]"
            :disabled="isSaving || isLoading"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="config.frontend_label"
            label="Butikknavn"
            hint="Vises til kunden i kassen, f.eks 'Betal ved levering'"
            :rules="[rules.required]"
            :disabled="isSaving || isLoading"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="config.description"
            label="Beskrivelse til kunde"
            hint="Vises til kunde ved valgt metode, f.eks 'Husk å ta med kontanter'"
            :disabled="isSaving || isLoading"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            type="submit"
            :disabled="isLoading || isSaving"
            :loading="isSaving"
            color="success"
          >
            <v-icon left> mdi-content-save </v-icon>
            Lagre
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import backend from "@/backend";

export default {
  name: "OfflineConfiguration",

  props: {
    organizationId: {
      type: Number,
      required: true,
    },
  },

  data: function () {
    return {
      isSaving: false,
      isLoading: true,
      rules: {
        required: (v) => !!v || "Dette feltet er påkrevd.",
      },
      config: {
        organization: this.organizationId,
        id: null,
        name: "",
        "frontend label": "",
        description: "",
      },
    };
  },

  async created() {
    const config = await backend.get("offlineconfigurations/", {
      organization: this.organizationId,
    });

    if (config.length == 1) {
      this.config = config[0];
    }

    this.isLoading = false;
  },

  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.isSaving = true;

        if (this.config.id) {
          this.config = await backend.put(
            `offlineconfigurations/${this.config.id}/`,
            this.config,
            {
              organization: this.organizationId,
            }
          );
        } else {
          this.config = await backend.post(
            `offlineconfigurations/`,
            this.config,
            {
              organization: this.organizationId,
            }
          );
        }

        this.$store.dispatch("add", {
          type: "success",
          message: "Offline konfigurasjon er nå lagret.",
        });

        this.isSaving = false;
      }
    },
  },
};
</script>
